import React, { useState } from 'react';
import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { BsFillTrashFill } from 'react-icons/bs';

import { useFormikContext } from 'formik';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { ConfirmationModal } from '@components/Modals';
import { Page500 } from '@containers/ErrorPages/Page500';
import { numberApi } from '@reducers/number/number';

const OriginatingNetworksOptions = ({ data, isLoading, isError }) =>
  !isLoading && !isError
    ? data.map(({ value: networkID, name }) => (
        <option value={networkID} key={networkID}>
          {name}
        </option>
      ))
    : null;

export const Routing = ({ did, getQuery, deleteQuery }) => {
  const { values, handleChange, handleBlur } = useFormikContext();
  const { data: result, isLoading: getIsLoading, status } = getQuery;
  const [show, setShow] = useState(false);
  const originatingNetworks = numberApi.useGetOriginatingNetworksQuery();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const isLoading = originatingNetworks.isLoading || getIsLoading;

  if (isLoading) {
    return (
      <>
        <Accordion.Header>Routing number</Accordion.Header>
        <Accordion.Body>
          <DefaultSpinnerCenter />
        </Accordion.Body>
      </>
    );
  }
  const isRejected = status === 'rejected';
  return (
    <>
      <Accordion.Header>Routing number</Accordion.Header>
      <Accordion.Body>
        {!isRejected ? (
          <>
            <Row className="normalFontSize">
              <Col md={5}>Originating network</Col>
              <Col md={5}>Routing number</Col>
              <Col md={2} className="text-center">
                Delete
              </Col>
            </Row>
            <hr />
            {result.map(({ id }) => (
              <Form.Group
                as={Row}
                className="mb-3"
                controlId={`formGroupRouting-${id}`}
                key={id}
              >
                <Col md={5}>
                  <Form.Select
                    name={`routingNumber.${id}.originatingNetwork`}
                    size="sm"
                    value={values.routingNumber[id]?.originatingNetwork || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={originatingNetworks.isLoading}
                  >
                    <option value="">Choose Originating Network</option>
                    <OriginatingNetworksOptions
                      data={originatingNetworks.data}
                      isLoading={originatingNetworks.isLoading}
                      isError={originatingNetworks.isError}
                    />
                  </Form.Select>
                </Col>
                <Col md={5}>
                  <Form.Control
                    name={`routingNumber.${id}.routingNumber`}
                    size="sm"
                    value={values.routingNumber[id]?.routingNumber || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Enter routing number"
                  />
                </Col>
                <Col md={2} className="text-center">
                  {id ? (
                    <>
                      <Button variant="didxl" onClick={handleShow}>
                        <BsFillTrashFill size={17} />
                      </Button>
                      <ConfirmationModal
                        message={`Do you want to clear the routing number for DID - ${did}?`}
                        show={show}
                        onHide={handleClose}
                        handleConfirm={() => deleteQuery({ did, id })}
                      />
                    </>
                  ) : null}
                </Col>
              </Form.Group>
            ))}
            {[...Array(3 - result.length)].map((_, index) => (
              <Form.Group
                as={Row}
                className="mb-3"
                controlId={`formGroupBlankRouting-${index}`}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
              >
                <Col md={5}>
                  <Form.Select
                    name={`addRoutingNumber.${index}.originatingNetwork`}
                    size="sm"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={
                      values.addRoutingNumber[index]?.originatingNetwork || ''
                    }
                    disabled={originatingNetworks.isLoading}
                  >
                    <option value="">Choose Originating Network</option>
                    <OriginatingNetworksOptions
                      data={originatingNetworks.data}
                      isLoading={originatingNetworks.isLoading}
                      isError={originatingNetworks.isError}
                    />
                  </Form.Select>
                </Col>
                <Col md={5}>
                  <Form.Control
                    name={`addRoutingNumber.${index}.routingNumber`}
                    size="sm"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.addRoutingNumber[index]?.routingNumber || ''}
                    placeholder="Enter routing number"
                  />
                </Col>
                <Col md={2} className="text-center">
                  <Button variant="didxl" disabled>
                    <BsFillTrashFill size={17} />
                  </Button>
                </Col>
              </Form.Group>
            ))}
          </>
        ) : (
          <Page500 />
        )}
      </Accordion.Body>
    </>
  );
};
